import AgyleMultiselectDropdown from '../../../../components/ui/selector/agyleMultiselectDropdown';
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    clearAssessmentFilter,
    ctxAssessmentFilters,
    setAssessmentFilters,
} from '../../../../store/reducers/patientContext';
import {useTranslation} from 'react-i18next';
import {Grid} from '@mui/material';
import useDict from '../../../../hooks/useDict';
import useWardDict from '../../../../hooks/useWardDict';
import {AGE_DICT} from '../../../admin/ward/components/assessmentUtil';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';

const AssessmentsHeader = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const filter = useSelector(ctxAssessmentFilters);

    // Dict
    const [specialties] = useDict('Specialties', '', 'relevent eq true');
    const [trudWardList] = useWardDict();

    const handleChangeFilter = (val, e) => {
        const {name} = e.target;
        dispatch(setAssessmentFilters({
            ...filter,
            [name]: val,
        }));
    };

    const isFilterSelected = useCallback(() => {
        return filter?.ageRestriction?.length > 0 || filter?.specialities?.length > 0 || filter?.clinics?.length > 0;
    }, [filter]);

    return (
        <Grid container direction="row" spacing={1} style={{padding: '10px 0'}}>
            <Grid item xs={1}>
                {isFilterSelected() &&
                    <AgyleButton
                        variant="outlined"
                        colour="primary"
                        onClick={() => dispatch(clearAssessmentFilter())}
                    >
                        {t('Clear')}
                    </AgyleButton>
                }
            </Grid>

            <Grid item xs={5}/>

            <Grid item xs={2}>
                <AgyleMultiselectDropdown
                    label={t('Age Restriction')}
                    name="ageRestriction"
                    onChange={handleChangeFilter}
                    options={AGE_DICT}
                    value={filter?.ageRestriction}
                    size="small"
                    pathToItemValue="__id"
                    fullObjecValue
                />
            </Grid>

            <Grid item xs={2}>
                <AgyleMultiselectDropdown
                    label={t('Specialities')}
                    name="specialities"
                    onChange={handleChangeFilter}
                    options={specialties}
                    value={filter?.specialities}
                    size="small"
                    pathToItemValue="__id"
                    fullObjecValue
                />
            </Grid>

            <Grid item xs={2}>
                <AgyleMultiselectDropdown
                    label={t('Location')}
                    name="clinics"
                    onChange={handleChangeFilter}
                    options={trudWardList}
                    value={filter?.clinics}
                    size="small"
                    optionLabel="wardName"
                    pathToItemValue="__id"
                    fullObjecValue
                />
            </Grid>
        </Grid>
    );
};

export default AssessmentsHeader;